import React from "react";
import { Navigate, Outlet } from "react-router-dom";

import "./MobileLayout.css";

export default function MobileLayout() {
  const token = localStorage.getItem("token");

  if (!token) {
    return <Navigate to="/login" replace />;
  }
  return (
    <div className="mobile-app">
      <main className="mobile-main">
        <Outlet />
      </main>
    </div>
  );
}
